import { offer1, offer2, offer3, offer4 } from "../assets/imagesPath";

export const cardData = [
    {
      imageSrc: offer1,
      title: 'Strategic Business Advisory',
      listItems: [
        'Comprehensive business planning and goal setting.',
        'Entity structuring and optimization (LLC and S-Corp setups).',
        'Profitability analysis and growth strategies.',
      ],
    },
    {
      imageSrc: offer2,
      title: 'Financial Management Advisory',
      listItems: [
        'Budgeting and cash flow management.',
        'Tax planning strategies to maximize savings.',
        'Multi-entity financial organization and compliance.',
      ],
    },
    {
      imageSrc: offer3,
      title: 'Customized Solutions for Tradespeople',
      listItems: [
        'Services tailored to electricians, plumbers, remodelers, and other trade professionals.',
        'Bookkeeping solutions integrated with financial strategy.',
        'Payroll setup and management through trusted platforms like Paychex and ADP.',
      ],
    },
    {
      imageSrc: offer4,
      title: 'Tax Advisory Services',
      listItems: [
        'Efficient tax planning to minimize liabilities.',
        'Collaboration with tax professionals for compliance and optimization.',
        'Providing the best tax Advisory services.',
      ],
    },
  ];
